<template>
    <div>
        <div class="prg-margin">
            <label>First choice</label><br/>
            <select v-model="internal[0]" >
                <option :value="null">-- leave blank --</option>
                <option v-for="option in remaining(0)" :value="option" :key="option">{{option}}</option>
            </select>
        </div>

        <div class="prg-margin">
            <label>Second choice</label><br/>
            <select v-model="internal[1]" >
                <option :value="null">-- leave blank --</option>
                <option v-for="option in remaining(1)" :value="option" :key="option">{{option}}</option>
            </select>
        </div>

        <div class="prg-margin">
            <label>Third choice</label><br/>
            <select v-model="internal[2]" >
                <option :value="null">-- leave blank --</option>
                <option v-for="option in remaining(2)" :value="option" :key="option">{{option}}</option>
            </select>
        </div>

        <div class="prg-margin">
            <label>Fourth choice</label><br/>
            <select v-model="internal[3]" >
                <option :value="null">-- leave blank --</option>
                <option v-for="option in remaining(3)" :value="option" :key="option">{{option}}</option>
            </select>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'v-prg-field',
        props:['value', 'field'],
        data(){
            return{
                'internal':[null, null, null, null],
            }
        },
        watch:{
            'internal':{
                handler(){ this.$emit('input', this.internal) }
            }
        },
        methods:{
            remaining: function(i) {
                return this.field.options
                    .filter(o => o !== this.internal[0] || i == 0)
                    .filter(o => o !== this.internal[1] || i == 1)
                    .filter(o => o !== this.internal[2] || i == 2)
                    .filter(o => o !== this.internal[3] || i == 3)
            }
        }
    }
</script>

<style scoped lang="scss">
    .prg-margin{
        margin-bottom: 10px;
    }
</style>
